const mapUrl = document
  .querySelector('meta[name="mapUrl"]')
  .getAttribute('content');

const mapData = eval(
  document.querySelector('meta[name="mapData"]').getAttribute('content'),
);

export { mapUrl, mapData };



// WEBPACK FOOTER //
// ./src/js/maps/map-data.js